/**
 * Created by Christof Sander on 20.10.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],

	methods: {
		onAttachDone: function(){
			var scopeRoles;
			// select right scopeRoles if necessary
			if(this.resourceData.data && this.resourceData.data.children && this.resourceData.data.children.um_users_scopeRoles && (scopeRoles = this.resourceData.data.children.um_users_scopeRoles.data)){

				// reset dirty fields to prevent unnecessary deletions if necessary
				if(((((this.model.dirtyFields || {}).data || {}).children || {}).um_users_scopeRoles || {}).data){
					this.model.dirtyFields.data.children.um_users_scopeRoles.data = [];
				}

				this.find('templates_scopeTrees_selectScopeRoles', function(component){
					component.selectScopeRoles(scopeRoles);
				});
			}
		}
	}
};